import React from 'react';
import { Chip, ChipProps } from '@mui/material';
import {
  CheckCircle as ActiveIcon,
  Cancel as InactiveIcon,
  Pause as PendingIcon,
} from '@mui/icons-material';

interface StatusBadgeProps extends Omit<ChipProps, 'color'> {
  status: 'active' | 'inactive' | 'pending' | string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, ...props }) => {
  const getStatusConfig = (status: string) => {
    switch (status.toLowerCase()) {
      case 'active':
        return {
          color: 'success' as const,
          icon: <ActiveIcon />,
          label: 'Active',
        };
      case 'inactive':
        return {
          color: 'error' as const,
          icon: <InactiveIcon />,
          label: 'Inactive',
        };
      case 'pending':
        return {
          color: 'warning' as const,
          icon: <PendingIcon />,
          label: 'Pending',
        };
      default:
        return {
          color: 'default' as const,
          icon: undefined,
          label: status.charAt(0).toUpperCase() + status.slice(1),
        };
    }
  };

  const config = getStatusConfig(status);

  return (
    <Chip
      icon={config.icon}
      label={config.label}
      color={config.color}
      size="small"
      variant="filled"
      sx={{
        fontWeight: 500,
        minWidth: '80px',
        '& .MuiChip-icon': {
          fontSize: '16px',
        },
      }}
      {...props}
    />
  );
};

export default StatusBadge; 